export default __webpack_public_path__ + "static/media/data.5cca14ee.svg";